import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCountriesDataView } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { loadAllCountriesParameter } from "@store/Store/Data/Countries/Handlers/LoadAllCountries";

export function getAllCountries(state: ApplicationState) {
    return getCountriesDataView(state, loadAllCountriesParameter).value;
}
